 /*jshint esversion: 6 */

 import Vue from 'vue'
 import Router from 'vue-router'
 import Reader from '@/components/Reader'
 import Home from '@/components/home'
 import COVER from '@/components/cover'
 import TITLEPAGE from '@/components/titlepage'
 import COPYRIGHTPAGE from '@/components/copyright-page'
 import CHAPTER01A from '@/components/chapter01a'
 import CONTENTS from '@/components/contents'
 import CHAPTER01 from '@/components/chapter01'
 import CHAPTER03 from '@/components/chapter03'
 import CHAPTER04 from '@/components/chapter04'
 import CHAPTER05 from '@/components/chapter05'
 import CHAPTER06 from '@/components/chapter06'
 import CHAPTER07 from '@/components/chapter07'
 import CHAPTER08 from '@/components/chapter08'
 import CHAPTER09 from '@/components/chapter09'
 import CHAPTER10 from '@/components/chapter10'
 import CHAPTER11 from '@/components/chapter11'
 import CHAPTER12 from '@/components/chapter12'
 import CHAPTER13 from '@/components/chapter13'
 import CHAPTER14 from '@/components/chapter14'
 import CHAPTER15 from '@/components/chapter15'
 import CHAPTER16 from '@/components/chapter16'
 import CHAPTER17 from '@/components/chapter17'
 import CHAPTER18 from '@/components/chapter18'
 import CHAPTER19 from '@/components/chapter19'
 import CHAPTER20 from '@/components/chapter20'
 import CHAPTER21 from '@/components/chapter21'
 import CHAPTER22 from '@/components/chapter22'
 import CHAPTER23 from '@/components/chapter23'
 import CHAPTER24 from '@/components/chapter24'
 import CHAPTER25 from '@/components/chapter25'
 import CHAPTER26 from '@/components/chapter26'
 import CHAPTER27 from '@/components/chapter27'
 import CHAPTER28 from '@/components/chapter28'
 import CHAPTER29 from '@/components/chapter29'
 import CHAPTER30 from '@/components/chapter30'
 import CHAPTER31 from '@/components/chapter31'
 import CHAPTER32 from '@/components/chapter32'
 import CHAPTER33 from '@/components/chapter33'
 import CHAPTER34 from '@/components/chapter34'
 import CHAPTER35 from '@/components/chapter35'
 import CHAPTER36 from '@/components/chapter36'
 import CHAPTER37 from '@/components/chapter37'
 import CHAPTER38 from '@/components/chapter38'
 import CHAPTER39 from '@/components/chapter39'
 import CHAPTER40 from '@/components/chapter40'
 import CHAPTER41 from '@/components/chapter41'
 import CHAPTER42 from '@/components/chapter42'
 import CHAPTER43 from '@/components/chapter43'
 import CHAPTER44 from '@/components/chapter44'
 import CHAPTER45 from '@/components/chapter45'
 import CHAPTER46 from '@/components/chapter46'
 import CHAPTER47 from '@/components/chapter47'
 import CHAPTER48 from '@/components/chapter48'
 import CHAPTER49 from '@/components/chapter49'
 import CHAPTER50 from '@/components/chapter50'
 import CHAPTER51 from '@/components/chapter51'
 import CHAPTER52 from '@/components/chapter52'
 import CHAPTER53 from '@/components/chapter53'
 import CHAPTER54 from '@/components/chapter54'
 import CHAPTER55 from '@/components/chapter55'
 import CHAPTER56 from '@/components/chapter56'
 import CHAPTER57 from '@/components/chapter57'
 import CHAPTER58 from '@/components/chapter58'
 import CHAPTER59 from '@/components/chapter59'
 import CHAPTER60 from '@/components/chapter60'
 import CHAPTER61 from '@/components/chapter61'
 import CHAPTER62 from '@/components/chapter62'
 import CHAPTER63 from '@/components/chapter63'
 import CHAPTER64 from '@/components/chapter64'
 import CHAPTER65 from '@/components/chapter65'
 import CHAPTER66 from '@/components/chapter66'
 import CHAPTER67 from '@/components/chapter67'
 import CHAPTER68 from '@/components/chapter68'
 import CHAPTER69 from '@/components/chapter69'
 import CHAPTER70 from '@/components/chapter70'
 import CHAPTER71 from '@/components/chapter71'
 import CHAPTER72 from '@/components/chapter72'
 import CHAPTER73 from '@/components/chapter73'
 import CHAPTER74 from '@/components/chapter74'
 import CHAPTER75 from '@/components/chapter75'
 import CHAPTER76 from '@/components/chapter76'
 import CHAPTER77 from '@/components/chapter77'
 import CHAPTER78 from '@/components/chapter78'
 import CHAPTER79 from '@/components/chapter79'
 import CHAPTER80 from '@/components/chapter80'
 import CHAPTER81 from '@/components/chapter81'
 import CHAPTER82 from '@/components/chapter82'
 import CHAPTER83 from '@/components/chapter83'
 import CHAPTER84 from '@/components/chapter84'
 import CHAPTER85 from '@/components/chapter85'
 import CHAPTER86 from '@/components/chapter86'
 import CHAPTER87 from '@/components/chapter87'
 import CHAPTER88 from '@/components/chapter88'
 import CHAPTER89 from '@/components/chapter89'
 import CHAPTER90 from '@/components/chapter90'
 import CHAPTER91 from '@/components/chapter91'
 import CHAPTER92 from '@/components/chapter92'
 import CHAPTER93 from '@/components/chapter93'
 import CHAPTER94 from '@/components/chapter94'
 import CHAPTER95 from '@/components/chapter95'
 import CHAPTER96 from '@/components/chapter96'
 import CHAPTER97 from '@/components/chapter97'
 import CHAPTER98 from '@/components/chapter98'
 import CHAPTER99 from '@/components/chapter99'
 import CHAPTER100 from '@/components/chapter100'
 import CHAPTER101 from '@/components/chapter101'
 import CHAPTER102 from '@/components/chapter102'
 import CHAPTER103 from '@/components/chapter103'
 import CHAPTER104 from '@/components/chapter104'
 import CHAPTER105 from '@/components/chapter105'
 import CHAPTER106 from '@/components/chapter106'
 import CHAPTER107 from '@/components/chapter107'
 import CHAPTER108 from '@/components/chapter108'
 import CHAPTER109 from '@/components/chapter109'
 import CHAPTER110 from '@/components/chapter110'
 import CHAPTER111 from '@/components/chapter111'
 import CHAPTER112 from '@/components/chapter112'
 import CHAPTER113 from '@/components/chapter113'
 import CHAPTER114 from '@/components/chapter114'
 import CHAPTER115 from '@/components/chapter115'
 import CHAPTER116 from '@/components/chapter116'
 import CHAPTER117 from '@/components/chapter117'
 import CHAPTER118 from '@/components/chapter118'
 import CHAPTER119 from '@/components/chapter119'
 import CHAPTER120 from '@/components/chapter120'
 import CHAPTER121 from '@/components/chapter121'
 import CHAPTER122 from '@/components/chapter122'
 import CHAPTER123 from '@/components/chapter123'
 import CHAPTER124 from '@/components/chapter124'
 import CHAPTER125 from '@/components/chapter125'
 import CHAPTER126 from '@/components/chapter126'
 import CHAPTER127 from '@/components/chapter127'
 import CHAPTER128 from '@/components/chapter128'
 import CHAPTER129 from '@/components/chapter129'
 import CHAPTER130 from '@/components/chapter130'
 import CHAPTER131 from '@/components/chapter131'
 import CHAPTER132 from '@/components/chapter132'
 import CHAPTER133 from '@/components/chapter133'
 import CHAPTER134 from '@/components/chapter134'
 import CHAPTER135 from '@/components/chapter135'
 import CHAPTER136 from '@/components/chapter136'
 import CHAPTER137 from '@/components/chapter137'
 import CHAPTER138 from '@/components/chapter138'
 import CHAPTER139 from '@/components/chapter139'
 import CHAPTER140 from '@/components/chapter140'
 import CHAPTER141 from '@/components/chapter141'
 import CHAPTER142 from '@/components/chapter142'
 import CHAPTER143 from '@/components/chapter143'
 import CHAPTER144 from '@/components/chapter144'
 import CHAPTER145 from '@/components/chapter145'
 import CHAPTER146 from '@/components/chapter146'
 import CHAPTER147 from '@/components/chapter147'
 import CHAPTER148 from '@/components/chapter148'
 import CHAPTER149 from '@/components/chapter149'
 import CHAPTER150 from '@/components/chapter150'
 import CHAPTER151 from '@/components/chapter151'
 import CHAPTER152 from '@/components/chapter152'
 import CHAPTER152A from '@/components/chapter152a'
 import CHAPTER153 from '@/components/chapter153'
 import CHAPTER154 from '@/components/chapter154'
 import CHAPTER155 from '@/components/chapter155'
 import CHAPTER156 from '@/components/chapter156'
 import CHAPTER157 from '@/components/chapter157'
 import CHAPTER158 from '@/components/chapter158'
 import CHAPTER159 from '@/components/chapter159'
 import CHAPTER160 from '@/components/chapter160'
 import CHAPTER161 from '@/components/chapter161'
 import CHAPTER162 from '@/components/chapter162'
 import CHAPTER163 from '@/components/chapter163'
 import CHAPTER164 from '@/components/chapter164'
 import CHAPTER165 from '@/components/chapter165'
 import CHAPTER166 from '@/components/chapter166'
 import CHAPTER167 from '@/components/chapter167'
 import CHAPTER168 from '@/components/chapter168'
 import CHAPTER169 from '@/components/chapter169'
 import CHAPTER170 from '@/components/chapter170'
 import CHAPTER171 from '@/components/chapter171'
 import CHAPTER172 from '@/components/chapter172'
 import CHAPTER173 from '@/components/chapter173'
 import CHAPTER174 from '@/components/chapter174'
 import CHAPTER175 from '@/components/chapter175'
 import CHAPTER176 from '@/components/chapter176'
 import CHAPTER177 from '@/components/chapter177'
 import CHAPTER178 from '@/components/chapter178'
 import CHAPTER179 from '@/components/chapter179'
 import CHAPTER180 from '@/components/chapter180'
 import CHAPTER181 from '@/components/chapter181'
 import CHAPTER182 from '@/components/chapter182'
 import CHAPTER183 from '@/components/chapter183'
 import CHAPTER184 from '@/components/chapter184'
 import CHAPTER185 from '@/components/chapter185'
 import CHAPTER186 from '@/components/chapter186'
 import CHAPTER187 from '@/components/chapter187'
 import CHAPTER188 from '@/components/chapter188'
 import CHAPTER189 from '@/components/chapter189'
 import CHAPTER190 from '@/components/chapter190'
 import CHAPTER191 from '@/components/chapter191'
 import CHAPTER192 from '@/components/chapter192'
 import CHAPTER193 from '@/components/chapter193'
 import CHAPTER194 from '@/components/chapter194'
 import CHAPTER195 from '@/components/chapter195'
 import CHAPTER196 from '@/components/chapter196'
 import CHAPTER197 from '@/components/chapter197'
 import CHAPTER198 from '@/components/chapter198'
 import CHAPTER199 from '@/components/chapter199'
 import CHAPTER200 from '@/components/chapter200'
 import CHAPTER201 from '@/components/chapter201'
 import CHAPTER202 from '@/components/chapter202'
 import CHAPTER203 from '@/components/chapter203'
 import CHAPTER204 from '@/components/chapter204'
 import CHAPTER205 from '@/components/chapter205'
 import CHAPTER206 from '@/components/chapter206'
 import CHAPTER207 from '@/components/chapter207'
 import CHAPTER208 from '@/components/chapter208'
 import CHAPTER209 from '@/components/chapter209'
 import CHAPTER210 from '@/components/chapter210'
 import CHAPTER211 from '@/components/chapter211'
 import CHAPTER212 from '@/components/chapter212'
 import CHAPTER213 from '@/components/chapter213'
 import CHAPTER214 from '@/components/chapter214'
 import CHAPTER215 from '@/components/chapter215'
 import CHAPTER216 from '@/components/chapter216'
 import CHAPTER217 from '@/components/chapter217'
import Last from '@/components/last'

Vue.use(Router)

export default new Router({
	routes: [
	{
 			"path" : "/",
 			"name" : "home",
 			"component" : Home
 		},
 		{
 			"path" : "/contents",
 			"name" : "contents",
 			"component" : CONTENTS
 		},
 		{
 			"path" : "/chapter01",
 			"name" : "chapter01",
 			"component" : CHAPTER01
 		},
 		{
 			"path" : "/chapter03",
 			"name" : "chapter03",
 			"component" : CHAPTER03
 		},
 		{
 			"path" : "/chapter04",
 			"name" : "chapter04",
 			"component" : CHAPTER04
 		},
 		{
 			"path" : "/chapter05",
 			"name" : "chapter05",
 			"component" : CHAPTER05
 		},
 		{
 			"path" : "/chapter06",
 			"name" : "chapter06",
 			"component" : CHAPTER06
 		},
 		{
 			"path" : "/chapter07",
 			"name" : "chapter07",
 			"component" : CHAPTER07
 		},
 		{
 			"path" : "/chapter08",
 			"name" : "chapter08",
 			"component" : CHAPTER08
 		},
 		{
 			"path" : "/chapter09",
 			"name" : "chapter09",
 			"component" : CHAPTER09
 		},
 		{
 			"path" : "/chapter10",
 			"name" : "chapter10",
 			"component" : CHAPTER10
 		},
 		{
 			"path" : "/chapter11",
 			"name" : "chapter11",
 			"component" : CHAPTER11
 		},
 		{
 			"path" : "/chapter12",
 			"name" : "chapter12",
 			"component" : CHAPTER12
 		},
 		{
 			"path" : "/chapter13",
 			"name" : "chapter13",
 			"component" : CHAPTER13
 		},
 		{
 			"path" : "/chapter14",
 			"name" : "chapter14",
 			"component" : CHAPTER14
 		},
 		{
 			"path" : "/chapter15",
 			"name" : "chapter15",
 			"component" : CHAPTER15
 		},
 		{
 			"path" : "/chapter16",
 			"name" : "chapter16",
 			"component" : CHAPTER16
 		},
 		{
 			"path" : "/chapter17",
 			"name" : "chapter17",
 			"component" : CHAPTER17
 		},
 		{
 			"path" : "/chapter18",
 			"name" : "chapter18",
 			"component" : CHAPTER18
 		},
 		{
 			"path" : "/chapter19",
 			"name" : "chapter19",
 			"component" : CHAPTER19
 		},
		{
 			"path" : "/last",
 			"name" : "last",
 			"component" : Last
 		},
	]
})


// WEBPACK FOOTER //
// ./src/router/index.js